import { useCallback, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { styles } from './styles';
import { urlRegex } from 'utils/constants';

export const DraftCardMessage = ({ message }: { message: string }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      const isOverflown = node.scrollHeight > node.clientHeight;
      setIsOverflowing(isOverflown);
    }
  }, []);

  return (
    <Grid>
      <Grid
        ref={handleRef}
        sx={styles.typo(expanded)}
        component="div"
        dangerouslySetInnerHTML={{
          __html: message.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
          }),
        }}
      />
      {isOverflowing && (
        <Button sx={styles.button} onClick={() => setExpanded((prev) => !prev)}>
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </Grid>
  );
};
